var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicket = function SvgTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M5.5 1a1.5 1.5 0 0 0 3 0H11a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H8.5a1.5 1.5 0 0 0-3 0H3a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM4.402 2.499H3.5V6H5v1.5H3.5v3.999h.902l.065-.107a3 3 0 0 1 2.357-1.387L7 10c1.065 0 2 .555 2.533 1.392l.064.107h.903V7.5H9V6h1.5V2.499h-.903l-.064.11a3 3 0 0 1-2.357 1.386L7 4c-1.065 0-2-.555-2.533-1.392zM8 6v1.5H6V6z"
  })));
};
export default SvgTicket;